const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.CLIENTS)

export const apiClientDetails = {
	fetchClientDetailsFromAI: async (clientUUID: string): Promise<IClientDetailsFromAIModel> => {
		const response = await apiCommon<IClientDetailsFromAI>(`${groupPrefix}/ai/${clientUUID}`, {
			method: 'GET',
		})
		console.log(response)

		return ClientDetailsFromAI(response.data)
	},

	fetchDataSegments: async (clientID: number): Promise<IClientDataSegmentsModel> => {
		const { data } = await apiCommon<IClientDataSegments>(`${groupPrefix}/${clientID}/segments`, {
			method: 'GET',
		})

		return clientDataSegmentsFromJSON(data)
	},
}
